<template>
  <header class="header">
      <h1 class="header-title">
        <div class="text">{{$bus.transify['FLIP_TITLE']}}</div>
        <i @click="showRule" class="rule"></i>
        <i @click="showHistory" class="history"></i>
      </h1>
      <div class="header-right">
        <i class="diamond"></i>
        <div class="user-info">
          <span class="gems number-normal">{{getGem}}</span>
          <span class="user-id font-normal">ID: {{$bus.uid}}</span>
        </div>
      </div>
    </header>
</template>

<script>
export default {
  computed: {
    getGem: {
      get () {
        return this.$bus.gems
      },
      set (val) {
        this.$bus.gems = val
      }
    }
  },
  methods: {
    showHistory () {
      if (this.$bus.shuffleAnime || this.$bus.flipAnime) return
      this.$bus.getHistory()
    },
    showRule () {
      if (this.$bus.shuffleAnime || this.$bus.flipAnime) return
      this.$bus.rule.show = true
      this.$bus.addGA('rule', 'show')
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  @include px2res(height, 72);
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.header-right {
  position: absolute;
  @include px2res(right, 16);
  @include px2res(top, 5);
  .diamond {
    position: absolute;
    @include px2res(left, -36);
    @include px2res(top, 3);
    @include px2res(width, 26);
    @include px2res(height, 24);
  }
  .gems {
    @include px2res(font-size, 30);
    @include px2res(height, 30);
    line-height: 1.1;
    color: #F1F1F1;
    font-family: $number-font-family;
  }
  .user-info {
    @include flexcc;
    align-items: flex-start;
  }
  .user-id {
    @include px2res(font-size, 16);
    color: #F2F2F2;
  }
}

.header-title {
  text-transform: uppercase;
  position: absolute;
  left: 48%;
  top: 50%;
  transform: translate(-50%, -50%);
  @include px2res(height, 72);
  @include px2res(line-height, 72);
  @include px2res(padding, 0, 50);
  @include px2res(font-size, 50);
  @include px2res(letter-spacing, .5);
  white-space: nowrap;
  .text {
    overflow: visible;
    font-style: italic;
    font-weight: 500;
    color: rgba(255, 205, 144, 1);
    -webkit-text-stroke: 1px rgba(0, 0, 0, .5);
    text-shadow: 2px 3px 4px rgba(48, 2, 2, 0.36);
    @include px2res(padding, 0, 10);
    // @include text-gradient(#ffd6a4 70%, #ffc47d 30%);
  }
  .rule,
  .history {
    display: block;
    position: absolute;
    top: 50%;
    transform: translate(0, -54%);
    @include px2res(width, 38);
    @include px2res(height, 38);
    @include px2res(right, 0);
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0);
  }
  .history {
    @include px2res(right, -46);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue